<ion-row
	[class.paid]="state === CheckoutItemStatus.PAID"
	class="checkout-item ion-align-items-center ion-padding-vertical-sm ion-padding-horizontal-md ion-margin-vertical-xs"
>
	<!-- media -->
	<ion-col class="col-media" size="auto">
		<ion-img [src]="image" class="thumb rounded-image"></ion-img>
	</ion-col>

	<!-- title -->
	<ion-col class="col-title">
		<div class="title truncate">{{ title }}</div>
		@if (hasDiscount) {
			<div class="sub-title truncate">{{ discount }}</div>
		}
	</ion-col>

	<!-- qty -->
	<ion-col class="col-meta" size="auto">
		<div class="title">{{ qty }}x</div>
	</ion-col>

	<!-- price -->
	<ion-col class="col-price" size="auto">
		<div class="title">{{ price }}</div>
	</ion-col>

	<!-- interactive controls -->
	@if (editable) {
		@switch (state) {
			@case (CheckoutItemStatus.TAKEN) {
				<img
					[alt]="'checkoutItem.altTaken' | translate"
					class="order-icon"
					height="27"
					ngSrc="/assets/icon/already-taken-order.svg"
					width="27"
				/>
			}
			@case (CheckoutItemStatus.AVAILABLE) {
				<img
					(click)="onItemToggle()"
					[alt]="'checkoutItem.altAddToOrder' | translate"
					class="order-icon"
					height="27"
					ngSrc="/assets/icon/add-order.svg"
					width="27"
				/>
			}
			@case (CheckoutItemStatus.PAID) {
				<img
					[alt]="'checkoutItem.altPaid' | translate"
					class="order-icon"
					height="27"
					ngSrc="/assets/icon/paid-order.svg"
					width="27"
				/>
			}
			@case (CheckoutItemStatus.SELECTED) {
				<img
					(click)="onItemToggle()"
					[alt]="'checkoutItem.altAddToOrder' | translate"
					class="order-icon"
					height="27"
					ngSrc="/assets/icon/added-order.svg"
					width="27"
				/>
			}
		}
	}
</ion-row>

<!-- MODIFIERS ROW -->
@if (item?.modifiers?.length && !isGamePlay) {
	<ion-row class="checkout-item-mods ion-padding-vertical-xs ion-padding-horizontal-md ion-margin-vertical-xs">
		<ion-col class="col-media-spacer" size="auto"></ion-col>
		<ion-col>
			<ul class="modifiers">
				@for (m of item?.modifiers; track m.id) {
					<li class="truncate">{{ modifierText(m) }}</li>
				}
			</ul>
		</ion-col>
	</ion-row>
}
